import { formacoes } from "@/data/formacoes";
import { buildWhatsAppLink } from "@/lib/whatsapp";

export const Formacoes = () => {
  return (
    <section
      id="formacoes"
      data-testid="formacoes-section"
      className="bg-white py-28 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end mb-20 md:mb-28">
          <div className="lg:col-span-7 reveal">
            <div className="flex items-center gap-4 mb-8">
              <span className="rule-yellow" />
              <span className="eyebrow">Formações da Academy</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[3.6rem] leading-[1.05] tracking-tight text-[#0a0a0a]">
              Treinamentos pensados para
              <br />
              <em className="italic">cada etapa da jornada profissional.</em>
            </h2>
          </div>
          <div className="lg:col-span-5 reveal">
            <p className="text-base md:text-lg leading-relaxed text-[#3a3a3a] max-w-md lg:ml-auto">
              Cinco formações que conversam entre si: do primeiro passo na
              profissão à inteligência de crescimento do salão. Nada de
              fórmulas mágicas. Método, repertório e clareza.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#e5e2db] border border-[#e5e2db]">
          {formacoes.map((f, idx) => (
            <article
              key={f.id}
              data-testid={`formacao-card-${f.id}`}
              className={`bg-white p-10 md:p-14 editorial-card border-r border-b border-transparent hover:border-[#f4c542] group flex flex-col ${
                f.featured ? "md:col-span-2 md:bg-[#fafaf7]" : ""
              }`}
              style={{ transitionDelay: `${idx * 50}ms` }}
            >
              <div className="flex items-start justify-between mb-10">
                <span className="eyebrow text-[#7a5a00]">{f.eyebrow}</span>
                <span className="font-display text-2xl text-[#0a0a0a]/30 group-hover:text-[#f2b705] transition-colors">
                  {String(idx + 1).padStart(2, "0")}
                </span>
              </div>

              <h3
                className={`font-display leading-tight text-[#0a0a0a] mb-5 ${
                  f.featured
                    ? "text-3xl md:text-4xl lg:text-5xl"
                    : "text-3xl md:text-4xl"
                }`}
              >
                {f.title}
              </h3>
              <p
                className={`text-[15px] md:text-base leading-relaxed text-[#3a3a3a] mb-6 ${
                  f.featured ? "max-w-2xl" : "max-w-md"
                }`}
              >
                {f.description}
              </p>

              {f.note && (
                <p
                  data-testid={`formacao-note-${f.id}`}
                  className="text-[13px] md:text-sm italic text-[#6b6b6b] mb-10 max-w-md"
                >
                  {f.note}
                </p>
              )}

              <div className="mt-auto flex flex-wrap items-center justify-between gap-4 pt-8 border-t border-[#e5e2db]">
                <span className="text-[12px] tracking-[0.16em] uppercase text-[#6b6b6b]">
                  {f.duration}
                </span>
                <a
                  href={buildWhatsAppLink(f.whatsappMessage)}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`formacao-cta-${f.id}`}
                  className="inline-flex items-center gap-2 text-[12px] tracking-[0.18em] uppercase font-semibold text-[#0a0a0a] hover:text-[#7a5a00] transition-colors"
                >
                  Saiba mais
                  <span
                    aria-hidden
                    className="inline-block transition-transform group-hover:translate-x-1"
                  >
                    →
                  </span>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
